"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveMachineAds = saveMachineAds;
async function saveMachineAds(advertisingRepo, machineId, payload) {
    return advertisingRepo.saveMachineAds(machineId, payload);
}
